{
  "id": "bast",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Bast",
    "en": "Bast"
  },
  "icon": "gods/bast",
  "portrait": "gods/bast-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "sphinx": 1
  },
  "unlocks": ["sphinx", "adze-of-wepwawet", "sacred-cats", "criosphinx", "hieracosphinx"],
  "powers": ["eclipse"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Goddess of protection and cats. Focus: Laborers. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 150 s."
  }
}
